import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { VALIDATION_FIELD_MAPPING } from '../../../../../utils/appConstant';
import ElipsisCell from "../../../../../components/TableBox/Cells/EllipsisCell";
import ElipsisText from "../../../../../components/ElipsisText";
import Dropdown from "../../../../../components/Dropdown";
import { RowClassName } from "../../../../../enums";
import { TableContext } from "../../../../../contexts/TableContext";
import { AddEdit as AddEditInterface } from '../../../../../interfaces/property.interface';
import { Validation } from '../../../../../interfaces/common';
import Checkbox from "../../../../../components/Checkbox";

interface RowProps {
  item: any;
  className?: RowClassName;
  view: boolean;
  allWhoCollectsMoneyOptions: any[];
  allWhoCollectsHstOptions: any[];
  allMatManagedByOptions: any[];
  formData: AddEditInterface;
  validation: Validation;
  onInputBlur: (e: any, name: string, platformId?: string) => void;
  onInputChange: (e: any, name: string, platformId?: string) => void;
}

const Row: React.FC<RowProps> = ({
  item, className, view, allWhoCollectsMoneyOptions, allWhoCollectsHstOptions, allMatManagedByOptions,
  formData, validation, onInputBlur, onInputChange
}) => {
  const { t } = useTranslation();
  const { headCells } = useContext(TableContext);

  const rowData = formData.propertyWhoCollects.find(propertyWhoCollect => propertyWhoCollect.platformId == item.id)

  const platformNode = (
    <div className="d-flex align-items-center">
      <img className="me-2" width={25} height={25} src={`/assets/images/${item.platform_name}.svg`} />
      <ElipsisText width="100%" text={item?.name || '-'} />
    </div>
  )

  return (
    <tr className={className}>
      {
        headCells.map((headCell) => {
          if (headCell.id === VALIDATION_FIELD_MAPPING.whoCollectsMoney) {
            return (
              <td key={item.id}>
                <div className="form-floating form-floating-outline">
                  <Dropdown
                    values={rowData?.whoCollectsMoney ? [rowData.whoCollectsMoney] : []}
                    options={(allWhoCollectsMoneyOptions || []).map((item: any) => ({
                      label: item.name,
                      value: item.id
                    }))}
                    allOptions={(allWhoCollectsMoneyOptions || []).map((item: any) => ({
                      label: item.name,
                      value: item.id
                    }))}
                    id={VALIDATION_FIELD_MAPPING.whoCollectsMoney}
                    name={VALIDATION_FIELD_MAPPING.whoCollectsMoney}
                    disabled={view || !rowData?.checked}
                    noSearch
                    required={rowData?.checked}
                    error={!!(rowData?.checked && validation.fields.find(field => field.field === VALIDATION_FIELD_MAPPING.whoCollectsMoney && field.platformId === item.id))}
                    errorMessage={validation.fields.find(field => field.field === VALIDATION_FIELD_MAPPING.whoCollectsMoney)?.message ?? ""}
                    placeholder={t('property.addEdit.pageTexts.form.whoCollectsMoney.placeholder')}
                    label={t('property.addEdit.pageTexts.form.whoCollectsMoney.label')}
                    onBlur={(_: any, name: string) => onInputBlur(_, name, rowData?.platformId)}
                    onChange={(_: any, name: string) => onInputChange(_, name, rowData?.platformId)}
                  />
                </div>
              </td>
            )
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.whoCollectsHst) {
            return (
              <td key={item.id}>
                <div className="form-floating form-floating-outline">
                  <Dropdown
                    values={rowData?.whoCollectsHst ? [rowData.whoCollectsHst] : []}
                    options={(allWhoCollectsHstOptions || []).map((item: any) => ({
                      label: item.name,
                      value: item.id
                    }))}
                    allOptions={(allWhoCollectsHstOptions || []).map((item: any) => ({
                      label: item.name,
                      value: item.id
                    }))}
                    id={VALIDATION_FIELD_MAPPING.whoCollectsHst}
                    name={VALIDATION_FIELD_MAPPING.whoCollectsHst}
                    disabled={view || !rowData?.checked}
                    noSearch
                    required={rowData?.checked}
                    error={!!(rowData?.checked && validation.fields.find(field => field.field === VALIDATION_FIELD_MAPPING.whoCollectsHst && field.platformId === item.id))}
                    errorMessage={validation.fields.find(field => field.field === VALIDATION_FIELD_MAPPING.whoCollectsHst)?.message ?? ""}
                    placeholder={t('property.addEdit.pageTexts.form.whoCollectsHst.placeholder')}
                    label={t('property.addEdit.pageTexts.form.whoCollectsHst.label')}
                    onBlur={(_: any, name: string) => onInputBlur(_, name, rowData?.platformId)}
                    onChange={(_: any, name: string) => onInputChange(_, name, rowData?.platformId)}
                  />
                </div>
              </td>
            )
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.matManagedBy) {
            return (
              <td key={item.id}>
                <div className="form-floating form-floating-outline">
                  <Dropdown
                    values={rowData?.matManagedBy ? [rowData.matManagedBy] : []}
                    options={(allMatManagedByOptions || []).map((item: any) => ({
                      label: item.name,
                      value: item.id
                    }))}
                    allOptions={(allMatManagedByOptions || []).map((item: any) => ({
                      label: item.name,
                      value: item.id
                    }))}
                    id={VALIDATION_FIELD_MAPPING.matManagedBy}
                    name={VALIDATION_FIELD_MAPPING.matManagedBy}
                    disabled={view || !rowData?.checked}
                    noSearch
                    required={rowData?.checked && formData.configureMatTax}
                    error={!!(rowData?.checked && validation.fields.find(field => field.field === VALIDATION_FIELD_MAPPING.matManagedBy && field.platformId === item.id))}
                    errorMessage={validation.fields.find(field => field.field === VALIDATION_FIELD_MAPPING.matManagedBy)?.message ?? ""}
                    placeholder={t('property.addEdit.pageTexts.form.matManagedBy.placeholder')}
                    label={t('property.addEdit.pageTexts.form.matManagedBy.label')}
                    onBlur={(_: any, name: string) => onInputBlur(_, name, rowData?.platformId)}
                    onChange={(_: any, name: string) => onInputChange(_, name, rowData?.platformId)}
                  />
                </div>
              </td>
            )
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.actions) {
            return (
              <td key={item.id}>
                <div className="form-floating form-floating-outline">
                  <Checkbox
                    variant='primary'
                    className='d-checkbox mb-0'
                    disabled={!!view}
                    checked={rowData?.checked ? true : false}
                    name={VALIDATION_FIELD_MAPPING.actions}
                    onChange={(_: any, name: string) => onInputChange(_, name, rowData?.platformId)}
                  />
                </div>
              </td>
            )
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.name) {
            return (
              <td key={item.id}>
                {platformNode}
              </td>
            )
          }

          return (<ElipsisCell key={headCell.id} width={headCell.width} text={item[headCell.id] || '-'} />);
        })
      }
    </tr>
  );
}

export default Row;
